import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CooperativeSetupService from "./CooperativeSetupServices";
import { toast } from "react-toastify";
import { successAlert } from "../../Global/GlobalSlice";

export const getCooperativeSetup = createAsyncThunk(
  "setup/getCooperativeSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CooperativeSetupService.getCooperativeSetup(
        data
      );
      // console.log({ responseData });
      // toast.dismiss();

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getCooperativeSetupById = createAsyncThunk(
  "setup/getCooperativeSetupById",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      // toast.loading("Processing");
      const responseData =
        await CooperativeSetupService.getCooperativeSetupById(data);
      // console.log({ responseData });
      // toast.dismiss();

      return responseData?.responseObject;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getCooperativeComponents = createAsyncThunk(
  "setup/getCooperativeComponents",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      // toast.loading("Processing");
      const responseData =
        await CooperativeSetupService.getCooperativeComponents(data);
      // console.log({ responseData });
      // toast.dismiss();

      return responseData;
    } catch (error) {
      toast.dismiss();
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createCooperativeComponent = createAsyncThunk(
  "setup/createCooperativeComponent",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await CooperativeSetupService.createCooperativeComponent(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else if (responseData?.successful === false) {
        toast.error(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const assignApprover = createAsyncThunk(
  "setup/assignApprover",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CooperativeSetupService.assignApprover(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else if (responseData?.successful === false) {
        toast.error(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllEmployees = createAsyncThunk(
  "paymentSetup/getAllEmployees",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CooperativeSetupService.getAllEmployees(data);

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  cooperativeSetup: {},
  cooperativeComponents: {},
  setupData: {},
  isLoading: false,
  error: null,
  employees: {},
};

const reducers = {
  viewSetup(state, action) {
    return { ...state, data: action.payload };
  },
};

export const CooperativeSlice = createSlice({
  name: "setup",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(getCooperativeSetup.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getCooperativeSetup.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          cooperativeSetup: action.payload,
        };
      })
      .addCase(getCooperativeSetup.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(assignApprover.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(assignApprover.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(assignApprover.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getAllEmployees.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getAllEmployees.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          employees: action.payload,
        };
      })
      .addCase(getAllEmployees.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getCooperativeSetupById.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getCooperativeSetupById.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          setupData: action.payload,
        };
      })
      .addCase(getCooperativeSetupById.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getCooperativeComponents.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getCooperativeComponents.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          cooperativeComponents: action.payload,
        };
      })
      .addCase(getCooperativeComponents.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(createCooperativeComponent.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(createCooperativeComponent.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(createCooperativeComponent.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
  },
});

export const { viewSetup } = CooperativeSlice.actions;

export default CooperativeSlice.reducer;
